export const state = () => ({})

export const actions = {
  async push({ commit }, data) {
    return await this.$gtm.push({ event: 'tEvent', ...data })
  },
}